export default "__VITE_ASSET__cr0R_twc__"